import React, { HTMLAttributes } from 'react'
import Link from 'next/link'

import styles from './styles.module.scss'

import { FranchiseDto } from '@services/api/franchise/types'
import cl from 'classnames'

interface DetailsProps extends HTMLAttributes<HTMLDivElement> {
  franchise: FranchiseDto
  action?: {
    title: string
    onClick?: () => void
  }
  isMap?: boolean
}

export const FranchiseCard = ({
  franchise,
  action,
  className,
  ...rest
}: DetailsProps) => (
  <div className={`${styles.container} ${className}`} {...rest}>
    <div className="h-full">
      <h2 className="mb-5">{franchise.titlePage.toUpperCase()}</h2>
      <p className="font-bold">{franchise.city}</p>
      <p className="font-bold">{franchise.shortState}</p>
    </div>
    <div
      className={cl(styles.actions, action ? 'justify-between' : 'justify-end')}
    >
      {action && (
        <button
          type="button"
          className={styles.button}
          onClick={() => action?.onClick()}
        >
          {action?.title}
        </button>
      )}

      <div className={styles.buttonContainer}>
        <Link
          href={`/fornecedores/empresas-de-energia-solar/${franchise.pathLocation}/${franchise.slug}`}
          className={styles.button}
          target="_blank"
        >
          saiba mais
        </Link>
      </div>
    </div>
  </div>
)
